module.exports = __webpack_public_path__ + "images/icons_v2/location-empty-filled-1096e892.svg";